import React from "react";
import { BarChart3Icon, ClipboardListIcon, CompassIcon, FrownIcon, KeyIcon, LibraryIcon, MoonIcon, PencilLineIcon, RulerIcon, SearchIcon, TimerIcon, TrendingDownIcon, BoxIcon } from "lucide-react";
const iconMap: Record<string, BoxIcon> = {
  frown: FrownIcon,
  timer: TimerIcon,
  search: SearchIcon,
  clipboard: ClipboardListIcon,
  trend: TrendingDownIcon,
  moon: MoonIcon,
  library: LibraryIcon,
  compass: CompassIcon,
  pencil: PencilLineIcon,
  ruler: RulerIcon,
  chart: BarChart3Icon,
  key: KeyIcon
};
type IconProps = {
  name: string;
  className?: string;
};
export function Icon({
  name,
  className
}: IconProps) {
  const Component = iconMap[name] ?? CompassIcon;
  return <Component className={className} aria-hidden="true" data-id="element-191" data-mp="2ufroasiqxras" />;
}